import React from "react";
import { useIsAdmin } from "../../../user";
import { Props } from "./types";
import { Navigation, NavLink } from "../../shared";
import messages from "./messages";
import { FormattedMessage } from "react-intl";
import { useAuth } from "../../../auth";

export const FooterNavigation: React.FC<Props> = (props) => {
  const [isAdmin] = useIsAdmin();
  const { parentClasses } = props;
  const [isAuth, , , logout] = useAuth();

  const global = (uri) => `https://www.basf.com/global/en/legal/${uri}.html`;
  return (
    <Navigation>
      {isAdmin ? (
        <NavLink parentClasses={parentClasses} to="/users">
          <FormattedMessage {...messages.usersList} />
        </NavLink>
      ) : null}
      {isAdmin ? (
        <NavLink parentClasses={parentClasses} to="/departments">
          <FormattedMessage {...messages.departments} />
        </NavLink>
      ) : null}
      <NavLink parentClasses={parentClasses} to="/contact">
        <FormattedMessage {...messages.contactAuthor} />
      </NavLink>
      <NavLink parentClasses={parentClasses} to={global("disclaimer")}>
        <FormattedMessage {...messages.disclaimer} />
      </NavLink>
      <NavLink parentClasses={parentClasses} to={global("data-protection")}>
        <FormattedMessage {...messages.dataProtection} />
      </NavLink>
      <NavLink parentClasses={parentClasses} to={global("credits")}>
        <FormattedMessage {...messages.credits} />
      </NavLink>
      {!isAuth && (
        <NavLink parentClasses={parentClasses} to="/privacy" targetBlank={true}>
          <FormattedMessage {...messages.privacy} />
        </NavLink>
      )}
    </Navigation>
  );
};
